<template>
  <BadgeWall></BadgeWall>
</template>
<script>
import BadgeWall from '@/components/BadgeWall' 
export default {
  components:{
    BadgeWall,
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped></style>
